// extracted by mini-css-extract-plugin
export default {"mainTagList":"MainTagListForStoreCategory_mainTagList__nBWfc"};